import React from "react";
import ReactDOM from "react-dom";
import { createGlobalStyle } from "styled-components";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./styles/index.less";
import "./styles/index.css";

Sentry.init({
  dsn: "https://30a543b7c7ee46d9ad7ce62c7f437eb6@o433255.ingest.sentry.io/5822310",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const GlobalStyles = createGlobalStyle`
  :root {
  --primary:${process.env.REACT_APP_PRIMARY_COLOR}
  }
`;

if (process.env.NODE_ENV === "production")
  document.domain = process.env.REACT_APP_OPENER_DOMAIN;

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyles />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
